module.exports = __webpack_public_path__ + "03_bg_mobile_new.f4cc16f9f22c216fd3df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/03_bg_mobile_new.jpg
// module id = 964
// module chunks = 7